<template>
  <div class="content">
    <div class="row filter-section">
      <div class="col-md-4">
        <ArtistSelect :is-filter="true" :initial-unit-id="$route.query.unitId ? parseInt($route.query.unitId, 10) : null" @memberChangeEvent="getArtistInfo" />
      </div>
      해당멤버 팔로워에게 푸시알림
    </div>

    <div class="row">
      <el-table :data="data">
        <el-table-column v-for="column in tableColumns" :key="column.label" :min-width="column.minWidth" :prop="column.prop" :label="column.label" />
        <el-table-column :min-width="50" align="right" label="푸시전송">
          <base-button slot-scope="props" @click.native.stop="sendNotification(props.row.id)" class="edit btn-link" type="warning" size="sm" icon>
            <i class="tim-icons icon-send" />
          </base-button>
        </el-table-column>
        <el-table-column :min-width="100" align="right" label="상태변경">
          <div slot-scope="props">
            <base-button @click.native="setTagVisible(props.row.id)" type="warning" size="sm" icon>
              <i class="tim-icons icon-settings" />
            </base-button>
          </div>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import ArtistSelect from "@/pages/Components/ArtistSelect.vue";
import { showAPIErrorToast } from "@/util/ErrorUtils";
import { Alert } from "@/util/Alert";

export default {
  name: "HotTags",
  components: {
    ArtistSelect,
  },
  async created() {},
  data() {
    return {
      data: [],
      tableColumns: [
        {
          prop: "tagId",
          label: "태그아이디",
          minWidth: 100,
        },
        {
          prop: "tag",
          label: "태그",
          minWidth: 100,
        },
        {
          prop: "count",
          label: "컨텐츠수",
          minWidth: 100,
        },
        {
          prop: "isVisible",
          label: "숨김여부",
          minWidth: 100,
        },
        {
          prop: "regTime",
          label: "등록시간",
          minWidth: 100,
        },
      ],
      unitId: null,
      isSendingPush: false,
    };
  },
  methods: {
    async getArtistInfo(param) {
      this.unitId = param.unitId;
      await this.getTags();
    },
    async getTags() {
      return this.$axios.get(`/fanLogs/${this.unitId}/tags`).then((res) => {
        this.data = res.data.data.map((item) => {
          item.isVisible = item.isVisible === 1 ? "노출" : "비노출";
          return item;
        });
      });
    },
    async setTagVisible(id) {
      return this.$axios.post(`/fanLogs/${this.unitId}/tags/${id}`).then((res) => {
        this.data = res.data.data;
        this.getTags();
      });
    },
    async sendNotification(id) {
      if (this.isSendingPush) {
        window.Toast.error("조금만 기다려 주세요! 이미 푸시를 전송 중이에요.");
        return;
      }

      if (await Alert.dangerousConfirmCancel("푸시 알림을 전송하시겠어요?")) {
        this.isSendingPush = true;
        try {
          await this.$axios.post(`/labs/${this.unitId}/keywords/${id}/notifications`, { artistId: this.artistId });
          window.Toast.success("푸시 알림이 전송 됐습니다");
        } catch (err) {
          showAPIErrorToast(err);
        } finally {
          this.isSendingPush = false;
        }
      }
    },
  },
};
</script>
<style lang="scss">
.table-view {
  margin-left: 0;
  margin-bottom: 60px;
}
.filter-section {
  margin-bottom: 50px;
}
</style>
